import './css/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import InfoOverlay from './info-overlay';
import { OverlayOptions } from 'enums/overlay-options';

export default class {

    static name = 'covenants-data';

    constructor( config ) {

        Object.assign( this, config );

        this.pageWrapper = document.querySelector( '.page' );

        this.root = createRoot( this.element );

    }

    ready() {

        this.root.render(
            <InfoOverlay
                data={ this.attributes.overlay }
                overlayType={ OverlayOptions.DEFAULT }
            />,
        );

    }

}
